import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { Result, Spin } from 'antd';
import { usePermissions } from 'hooks/usePermissions';
import { PERMISSION_DENIED_MESSAGE } from 'utils/errorHandling';

// ==============================|| PACKING ADVANCED ROUTE GUARD ||============================== //
// Ready Material page ko direct URL se khulne se rokta hai jab user ke paas
// packing_advanced.manage nahi. RoutePermissionGuard ki tarah sirf retailer par
// nahi — ye manufacturer family (grain_mill, flour_mill, manufacturer,
// manufacturing_2) par lagta hai, aur admin bypass NAHI hota (backend jaisa).
// Baaqi company types ke liye children seedha render hote hain.

export default function PackingAdvancedRouteGuard({ children }) {
  const { isManufacturer, companyType, permissions, canUsePackingAdvanced } = usePermissions();
  const [waited, setWaited] = useState(false);

  // Page refresh par scope/permissions API se aati hain; load hone tak thora intezar.
  const scopeLoading = !companyType && permissions.length === 0 && !waited;
  useEffect(() => {
    if (!scopeLoading) return undefined;
    const t = setTimeout(() => setWaited(true), 4000);
    return () => clearTimeout(t);
  }, [scopeLoading]);

  if (scopeLoading) {
    return (
      <div style={{ padding: 48, textAlign: 'center' }}>
        <Spin />
      </div>
    );
  }

  if (!isManufacturer || canUsePackingAdvanced()) return children;

  return <Result status="403" title={PERMISSION_DENIED_MESSAGE} subTitle="You do not have access to this page." />;
}

PackingAdvancedRouteGuard.propTypes = {
  children: PropTypes.node
};
